export const environment = {
  production: false,
  apiUrl: 'https://qhsuite-dev.qhantuy.com/'
};
